import isEqual from 'lodash/isEqual'

const DEFAULT_RANGE = [0, 9]
const DEFAULT_SORT_ORDER = 'asc'

const clearHealthEvents = state => {
  Object.assign(state, {
    healthEvents: []
  })
}

const setHealthEvents = (state, healthEvents) => {
  Object.assign(state, {
    healthEvents: [...state.healthEvents, ...healthEvents]
  })
}

const setSummaries = (state, summaries) => {
  Object.assign(state, { summaries })
}

const setCurrentSummary = (state, currentSummary) => {
  Object.assign(state, { currentSummary })
}

const setCurrentSecondaryFilters = (state, currentSecondaryFilters) => {
  Object.assign(state, { currentSecondaryFilters })
}

const setPoolFilters = (state, poolFilters) => {
  Object.assign(state, { poolFilters })
}

const setIsFetching = (state, isFetching) => {
  Object.assign(state, { pagination: { ...state.pagination, isFetching } })
}
const setPaginationError = (state, hasError) => {
  Object.assign(state, { pagination: { ...state.pagination, hasError } })
}

const setStopLoad = (state, stopLoad) => {
  Object.assign(state, { pagination: { ...state.pagination, stopLoad } })
}

const setRange = (state, range) => {
  Object.assign(state, { pagination: { ...state.pagination, range } })
}

const resetFiltersSortAndRange = state => {
  Object.assign(state, {
    filters: {},
    sortBy: 'due_date',
    sortOrder: DEFAULT_SORT_ORDER
  })

  setRange(state, DEFAULT_RANGE)
}

const sanitizeFilters = (state, { filters, cleanFilters }) => {
  if (cleanFilters) {
    resetFiltersSortAndRange(state)
  } else if (
    Object.keys(filters).length > 0 &&
    !isEqual(state.filters, filters)
  ) {
    state.filters = filters
  } else {
    state.filters = filters
  }

  Object.assign(state, { filters })
}

const updateHealthEventLocally = (state, data) => {
  const healthEvents = state.healthEvents.map(event =>
    event.id === data.id ? data : event
  )
  Object.assign(state, { healthEvents })
}

const removeHealthEventLocally = (state, id) => {
  const healthEvents = state.healthEvents.filter(event => event.id !== id)
  Object.assign(state, { healthEvents })
}

export default {
  clearHealthEvents,
  setHealthEvents,
  setSummaries,
  setCurrentSummary,
  setCurrentSecondaryFilters,
  setPoolFilters,
  setStopLoad,
  setRange,
  setPaginationError,
  setIsFetching,
  sanitizeFilters,
  updateHealthEventLocally,
  removeHealthEventLocally
}
